module.exports = __webpack_public_path__ + "img/ysgj_009@2x.6ad6ac31.png";